export default {
  common: {
    loadFailed: "読み込みに失敗しました。再試行してください。",
    saveFailed: "保存に失敗しました。再試行してください。",
    refresh: '更新', search: '検索', cancel: 'キャンセル', save: '保存', edit: '編集', delete: '削除', disable: '無効化', view: '表示',
    share: '共有', shared: '共有', revoke: '解除', authorize: '権限付与', actions: '操作', all: 'すべて', readOnly: '読み取り専用', collaboration: '共同編集',
    normal: '有効', disabled: '無効', enabled: '有効', closed: '無効', noData: 'データがありません', notFilled: '未入力', unassigned: '未割り当て',
    unknownOrganization: '不明な組織', selectOrganization: '組織を選択', includeChildren: '下位組織を含む', description: '説明', remarks: '備考',
    organization: '組織', owningOrganization: '所属組織', loginName: 'ログイン名', nickname: 'ニックネーム', phone: '電話番号', role: 'ロール', status: '状態',
    permission: '権限', validThrough: '有効期限', device: 'デバイス', deviceName: 'デバイス名', chipId: 'チップ ID', deviceType: 'デバイス種別', hardwareVersion: 'ハードウェアバージョン', softwareVersion: 'ソフトウェアバージョン', type: '種別', owner: '所有者',
    deviceKeywordPlaceholder: 'デバイス名、説明、またはチップ ID', selectUser: 'ユーザーを選択してください', saveSuccess: '保存しました',
    authorizationSuccess: '権限を付与しました', operationConfirm: '操作の確認', revoked: '解除しました'
  },
  theme: {
    exactPhone: '電話番号を入力してください。海外番号には国番号が必要です（他の組織も検索可能）',
    title: '組織テーマ', keywordPlaceholder: 'テーマ名、説明、または FourCC', themeName: 'テーマ名', editTitle: 'テーマメタデータを編集',
    shareTitle: 'テーマを共有', selectOrgUser: 'テーマ所属組織のユーザーを選択', confirmRevoke: 'このテーマ関係を解除しますか？'
  },
  management: {
    title: '組織管理', peopleManagement: 'メンバー管理', visibleOrganizations: '表示可能な組織', currentOrganization: '現在の組織', addChild: '下位組織を追加',
    organizationCode: '組織コード', level: '階層', path: 'パス', childOrganizations: '下位組織', dragToSort: '行をドラッグして同階層の順序を変更',
    saveOrder: '順序を保存', dragSort: 'ドラッグして並べ替え', noChildren: '下位組織はありません', selectLeftOrganization: '左側で組織を選択してください',
    editTitle: '組織を編集', createTitle: '組織を追加', organizationName: '組織名', parentOrganization: '上位組織', autoGenerated: 'システムで自動生成',
    enterOrganizationName: '組織名を入力してください', deleteConfirmMessage: '削除前に、この組織にユーザー、デバイス、テーマがないことを確認してください。',
    deleteConfirmTitle: '削除の確認', deleteSuccess: '削除しました', orderSaved: '順序を保存しました',
    moveParent: '上位組織を変更', moveTitle: '上位組織の変更', moveSource: '対象組織', moveTarget: '新しい上位組織',
    moveTargetPlaceholder: '組織名で絞り込み', selectedTarget: '選択した上位組織', moveReason: '理由', moveReasonPlaceholder: '任意の変更理由',
    previewImpact: '影響を確認', confirmMove: '変更を確定', moveBlocked: 'この変更は実行できません', moveSummary: '影響プレビュー',
    currentPath: '現在のパス', newPath: '変更後のパス', nodes: '組織数', users: 'ユーザー数', boards: 'デバイス数', themes: 'テーマ数',
    affectedSubadmins: '影響を受ける副管理者', selectMoveTarget: '新しい上位組織を選択してください',
    moveConfirmMessage: 'この組織とすべての下位組織を新しい上位組織へ移動しますか？ユーザー、デバイス、テーマの所属と個別権限は変更されません。',
    moveSuccess: '上位組織を変更しました'
  },
  users: {
    title: '組織メンバー', addUser: 'メンバーを追加', organizationScope: '組織範囲', keywordPlaceholder: 'ログイン名、ニックネーム、または電話番号',
    accountStatus: 'アカウント状態', changeOrganization: '組織を変更', resetPassword: 'パスワードをリセット', editTitle: 'メンバーを編集',
    createTitle: 'メンバーを追加', password: 'パスワード', keepPasswordPlaceholder: '変更しない場合は空欄', passwordPlaceholder: 'パスワードを入力',
    confirmPassword: 'パスワード確認', selectRole: 'ロールを選択', dataScope: 'データ範囲', moveTitle: 'メンバーの組織を変更', person: 'メンバー',
    targetOrganization: '変更先組織', detailsTitle: 'メンバー詳細', scopeCalculatedByServer: 'サーバーがロールに基づいて計算',
    selectTargetOrganization: '変更先組織を選択してください', organizationChanged: '組織を変更しました', completeUserInfo: '必須のメンバー情報を入力してください', saveFailed: 'メンバーの保存に失敗しました',
    passwordMismatch: 'パスワードが一致しません', enterNewPassword: '新しいパスワードを入力してください', passwordMinLength: 'パスワードは6文字以上必要です',
    passwordResetSuccess: 'パスワードをリセットしました', disableConfirm: '無効化するとこのアカウントはログインできません。続行しますか？',
    accountDisabled: 'アカウントを無効化しました'
  },
  roles: {
    title: 'ロールと権限', builtinRoles: '組み込みロール', code: 'コード', permissionPoints: '権限項目', group: 'グループ', permissionCode: '権限コード',
    name: '名前', roleHasPermission: 'ロールに付与済み', description: '説明'
  },
  myBoards: {
    title: 'マイメインボード', owned: '所有', relationship: '関係', capability: '操作範囲', operable: '操作可能', noValidRelations: '有効なデバイス関係がありません', renameTitle: 'メインボード名を変更', nameRequired: 'メインボード名を入力してください', renamed: 'メインボード名を更新しました'
  },
  orgBoards: {
    internalUsers: "組織内ユーザー",
    externalUsers: "外部協力者",
    source: "付与元",
    legacySource: "既存の関係",
    permanent: "無期限",
    expired: "期限切れ",
    editAuthorization: "デバイス権限を編集",
    exactPhone: "国番号を含む電話番号（例：+81）",
    futureExpiry: "有効期限は現在より後に設定してください",
    confirmExternal: "{user} に「{board}」の権限を付与しますか？権限：{permission}、期限：{expiry}。既存の権限は更新されます。",
    title: '組織デバイス', multipleOwners: '所有者が複数', ownerUnavailable: '所有者を利用できません', managementCapability: '管理範囲', userRelations: 'ユーザー関係',
    organizationAssignment: '所属組織', manageRelations: '関係を管理', transferOwner: '所有者を移管', relationsTitle: 'デバイスユーザー関係',
    selectOrganizationUser: '組織内のユーザーを選択', transferOwnerTitle: 'デバイス所有者を移管', newOwner: '新しい所有者',
    selectDeviceOrgUser: 'デバイス所属組織のユーザーを選択', confirmTransfer: '移管を確認', changeDeviceOrganization: 'デバイスの組織を変更',
    confirmRevoke: 'このデバイス関係を解除しますか？', assignOrganizationFirst: '先にデバイスの所属組織を設定してください',
    selectNewOwner: '新しい所有者を選択してください', ownerUpdated: '所有者を更新しました', organizationUpdated: '組織を更新しました', renameTitle: 'メインボード名を変更', nameRequired: 'メインボード名を入力してください', renamed: 'メインボード名を更新しました'
  },
  platformBoards: {
    title: 'プラットフォームデバイス運用', addDevice: 'デバイスを追加', taskLimit: 'タスク上限', sessionLimit: 'セッション上限',
    usedSessions: '使用済みセッション', bootCount: '起動回数', autoUpgrade: '自動アップグレード', platformValidity: 'プラットフォーム有効期限',
    lastOnline: '最終オンライン', assignOwner: '所有者を割り当て', reboot: '再起動', refurbish: '初期化', editTitle: 'プラットフォームデバイスを編集',
    createTitle: 'プラットフォームデバイスを追加', deviceDescription: 'デバイス説明', maxTasks: '最大タスク数', longTermPlaceholder: '空欄の場合は無期限',
    enterChipId: 'チップ ID を入力してください', enterDeviceName: 'デバイス名を入力してください', deviceUpdated: 'デバイスを更新しました',
    deviceCreated: 'デバイスを作成しました', enterTargetUserUid: '対象ユーザー UID を入力してください', assignOwnerTitle: 'デバイス所有者を割り当て',
    targetUserUidRequired: '対象ユーザー UID は必須です', rebootConfirm: 'このデバイスを再起動しますか？', rebootSent: '再起動コマンドを送信しました',
    refurbishConfirm: '初期化するとデバイス関係、テーマスナップショット、実行履歴が削除されます。続行しますか？', highRiskOperation: '高リスク操作',
    deviceRefurbished: 'デバイスを初期化しました', deleteConfirm: '削除するとデバイス関係、テーマスナップショット、実行履歴が削除されます。続行しますか？',
    deviceDeleted: 'デバイスを削除しました',
    manageCapabilities: 'メインボード権限',
    capabilityDescription: '実行期限の表示と管理者パラメータの変更だけを許可します。所有者や協力関係は変更しません。',
    capabilityUser: '許可するユーザー',
    capabilityType: '権限種別',
    boardAdminParamsCapability: '管理者パラメータ',
    capabilityGranted: '権限を付与しました',
    revokeCapabilityConfirm: 'このユーザーの管理者パラメータ権限を解除しますか？'
  },
  deviceTypes: { controlV5: 'メインコントローラー V5', controlV3: 'メインコントローラー V3', SNA: 'SNA', SNIO: 'SNIO', SNU: 'SNU', phone: '電話' },
  roleNames: {
    sivaadmin: 'システム管理者', admin: 'システム管理者', subadmin: 'サブ管理者', koradmin: 'サブ管理者', store_manager: '店舗管理者',
    employee: '従業員', platform_staff: 'プラットフォーム運用担当者'
  },
  dataScopes: { ALL: 'すべての組織', ORG_AND_CHILDREN: '現在の組織と下位組織', SELF_ORG: '現在の組織' },
  permissionGroups: { org: '組織', user: 'メンバー', board: 'デバイス', platform: 'プラットフォーム', theme: 'テーマ', role: 'ロール' },
  permissionNames: {
    org_view: '組織を表示', org_create: '組織を追加', org_update: '組織を編集', org_delete: '組織を削除', org_sort: '組織を並べ替え', org_move: '上位組織を変更',
    user_view: 'メンバーを表示', user_create: 'メンバーを追加', user_update: 'メンバーを編集', user_delete: 'メンバーを削除', user_disable: 'メンバーを無効化',
    user_password_reset: 'パスワードをリセット', user_role_set: 'メンバーロールを設定', user_org_move: 'メンバーの組織を変更',
    board_own_view: '自分のデバイスを表示', board_org_view: '組織デバイスを表示', board_org_set: 'デバイス組織を設定', board_user_set: 'デバイスユーザーを設定',
    board_external_share_set: 'デバイスを外部共有', board_owner_transfer: 'デバイス所有者を移管', board_capability_set: 'メインボード権限を設定', platform_board_ops: 'プラットフォームデバイス運用',
    theme_view: 'テーマを表示', theme_org_view: '組織テーマを表示', theme_edit: 'テーマを編集', theme_user_set: 'テーマユーザーを設定',
    role_view: 'ロールを表示', role_create: 'ロールを追加', role_update: 'ロールを編集', role_delete: 'ロールを削除', permission_view: '権限を表示'
  },
  permissionDescriptions: {
    org_view: '組織ツリーを表示', org_create: '組織を追加', org_update: '組織情報を変更', org_delete: '未使用の組織を削除', org_sort: '同階層の組織順序を変更', org_move: '組織を移動し下位パスを更新',
    user_view: '組織範囲内のメンバーを表示', user_create: '組織範囲内にメンバーを追加', user_update: '組織範囲内のメンバーを変更',
    user_delete: '組織範囲内のメンバーを削除または無効化', user_disable: 'メンバーのログインを無効化', user_password_reset: 'メンバーのパスワードをリセット',
    user_role_set: 'メンバーにロールを割り当て', user_org_move: 'メンバーの所属組織を変更', board_own_view: '所有および共有デバイスを表示',
    board_org_view: '組織範囲別にデバイスを表示', board_org_set: 'デバイスの所属組織を設定', board_user_set: 'デバイスユーザー関係を設定',
    board_external_share_set: '正確な電話番号でデバイスを共有', board_owner_transfer: 'デバイス所有権を移管', board_capability_set: '独立したメインボード権限を付与または解除', platform_board_ops: 'プラットフォームレベルのデバイス運用を実行',
    theme_view: 'ユーザー関係に基づいてテーマを表示', theme_org_view: '組織範囲別にテーマを表示', theme_edit: '関係と権限に基づいてテーマを編集',
    theme_user_set: 'テーマユーザー関係を設定', role_view: 'ロールを表示', role_create: 'カスタムロールを追加', role_update: 'カスタムロールを編集',
    role_delete: 'カスタムロールを削除', permission_view: '権限辞書を表示'
  }
}
